import { ref } from 'vue'

export const eventBus = ref({
  events: {},
  
  on(event, callback) {
    if (!this.events[event]) this.events[event] = []
    this.events[event].push(callback)
  },
  
  async emit(event, payload) {
    if (this.events[event]) {
      for (const callback of this.events[event]) {
        await callback(payload)  // Wait for each callback if it's async
      }
    }
  },
})
